import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const HeroImageBody = ({ src, className, children, alt }) => {
    return (
        <div className={className} data-testid="photo-hero-image-body">
            {children}
            <HeroSizer>
                <img src={src} alt={alt} title={alt} />
            </HeroSizer>
        </div>
    );
};

HeroImageBody.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.element
};

const HeroSizer = styled.div``;

const HeroImage = styled(HeroImageBody)`
    width: 100%;
    height: 100%;
    position: relative;

    ${HeroSizer} {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    img {
        max-width: 100%;
        max-height: 50vh;
        width: auto;
        height: auto;
    }

    @media (min-width: 960px) {
        img {
            object-fit: contain;
            object-position: center;
            max-height: 40.3125rem;
            margin-top: 0.5rem; /*  8px */
            margin-bottom: 0.5rem; /* 8px */
            height: 100%;
        }
    }
    ${({ ratio }) =>
        ratio < 1 &&
        `
            @media (min-width: 960px) {
                img {
                    margin-top: 2.5rem; /*  36px */
                    margin-bottom: 2.5rem; /* 36px */
                }
            }
        `}
`;

HeroImage.propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default HeroImage;
